import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  useTheme,
  Dialog,
  DialogTitle,
  Button,
  DialogContentText,
} from "@mui/material";
import {
  useEffect,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
  memo,
  useMemo,
  useCallback,
  MouseEvent as ReactMouseEvent,
  ReactNode,
} from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
import dayjs from "dayjs";
//src
import Check from "../../../../images/icons/white_edit/Check_white.svg";
import MOCK_IMAGE from "../../../../images/mock_images/pointcloud_img2.png";
import AR_IMAGE from "../../../../images/mock_images/ar_img.png";
import { config } from "../../../config/config";
import {
  deleteContext,
  EViewType,
  renameDialogContext,
  deleteDialogContext,
} from "../../../pages/Home";
import { useInView } from "react-intersection-observer";
import { MoreVert } from "@mui/icons-material";
import { Common } from "../../../../common/src";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { t } from "i18next";
import POINT_REMOVE_WHITE_IMG from "../../../../images/icons/white_edit/point_remove.svg";
import POINT_REMOVE_IMG from "../../../../images/icons/point_remove.svg";
import ChevronRight from "../../../../images/icons/neutral_edit/Chevron Right.svg";
import Icon from "../../Icon";
import { projectDetailAPIs } from "../../../api/project";
import { uploadDialogContext } from "../../../pages/Home";
import Clusterings from "../../Utility/Clusterings";
import { openProjectAfterCheck } from "./OpenProjectTab";
import { useNavigate } from "react-router-dom";

type StatusIconProps = {
  status: 0 | 1 | 2; // 0:default/1:success/2:error
  number: number;
};

//new status text
const StatusIcon = (props: StatusIconProps) => {
  return (
    <Box component={"div"} sx={{ display: "inline-block" }}>
      {props.status === 1 ? (
        <Box
          component={"div"}
          className={
            props.number === 5
              ? "pj-status-dashboard comm-status"
              : "pj-status comm-status"
          }
        >
          <img src={Check} alt="" />
        </Box>
      ) : props.status === 2 ? (
        <Box
          component={"div"}
          className="pj-status1 comm-status"
          sx={{ color: "#FFFFFF" }}
        >
          {props.number}
        </Box>
      ) : (
        <Box
          component={"div"}
          className="pj-status2 comm-status"
          sx={{ color: "#FFFFFF" }}
        >
          {props.number}
        </Box>
      )}
    </Box>
  );
};

type StatusTextProps = {
  status: Common.PROJECT_STATUS_LIST;
  isLanguage: boolean;
  /**
   * List view: let a long status wrap onto at most 2 lines. Honours the "\n"
   * placed in SCQuick3DDict.json (e.g. "座標系変換または\n座標変換完了" → 2 lines).
   * Grid view omits this prop to keep the 28px box aligned with the StatusIcon row.
   */
  wrapTwoLines?: boolean;
};

const StatusText = (props: StatusTextProps) => {
  const { t } = useTranslation();
  const text = () => {
    let helmertError = false;

    // どちらかがエラー & どちらも成功していない
    if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      if (
        !(
          props.status.helmert_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED ||
          props.status.coordinate_transformation ===
            Common.PROJECT_STATUS_ENUM.COMPLETED
        )
      ) {
        helmertError = true;
      }
    }

    if (props.status.is_ar) {
      switch (props.status.ar_processing) {
        case Common.PROJECT_STATUS_ENUM.COMPLETED:
        case Common.PROJECT_STATUS_ENUM.INCOMPLETE:
          return t("AR_UPLOAD_COMPLETE");
        case Common.PROJECT_STATUS_ENUM.PROCESSING:
          return t("AR_UPLOAD_CONVERTING");
        case Common.PROJECT_STATUS_ENUM.ERROR:
          return t("AR_UPLOAD_FAILED");
      }
    } else if (helmertError) {
      return t("COORDINATE_CHANGE_ERROR");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
    ) {
      return t("SFM_PROCESSING_ERROR");
    } else if (props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR) {
      return t("UPLOAD_ERROR");
    } else if (
      props.status.dashboard_upload_las_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_las_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.dashboard_upload_txt_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.landlog_viewer_upload_sfm ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("DASHBOARD_UPLOAD_COMPLETE");
    } else if (
      props.status.verification_helmert ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.verification_sfm === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("ACCURACY_VERIFY_COMP");
    } else if (
      props.status.helmert_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.coordinate_transformation ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("COORDINATE_CHANGE_COMPLETE");
    } else if (
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.COMPLETED
    ) {
      return t("PROCESSING_DONE");
    } else if (
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.COMPLETED ||
      props.status.lidar_upload === Common.PROJECT_STATUS_ENUM.WAITING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.PROCESSING ||
      props.status.sfm_processing === Common.PROJECT_STATUS_ENUM.WAITING
    ) {
      return t("UPLOAD_COMPLETE");
    } else {
      return "";
    }
  };
  return (
    <Typography
      variant="body2"
      component="div"
      sx={
        props.wrapTwoLines
          ? {
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              // ja splits into exactly 2 lines thanks to the "\n" in the dict.
              // Latin languages have segments wider than the column, so they
              // end up truncated with "…" at the end of line 2.
              WebkitLineClamp: 2,
              overflow: "hidden",
              // Required: turns the "\n" in SCQuick3DDict.json into a real line break.
              whiteSpace: "pre-line",
              lineHeight: 1.3,
              wordBreak: "break-word",
            }
          : {
              display: "flex",
              alignItems: "center",
              height: "28px",
              lineHeight: "1.0",
            }
      }
    >
      {text()}
    </Typography>
  );
};

type Props = {
  project: Common.Project;
  selectProject: Common.Project[];
  setSelectProject: (project: Common.Project[]) => void;
  jobsiteNameList: Common.LandlogJobSite[];
  userNameList: Common.ProjectUserList[];
  isLanguage: boolean;
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  isARAvailable: boolean;
  viewType: EViewType;
  sortBy?: string;
};

const Project = (props: Props) => {
  // console.log("project");

  // Memoize filtered jobsite and user to avoid array.filter() on every render
  const { jobsiteName: memoizedJobsiteName, userName: memoizedUserName } =
    useMemo(() => {
      const jobsite =
        props.jobsiteNameList?.find(
          (data) => data.id === props.project.jobSiteId,
        )?.name || "";
      const user =
        props.userNameList?.find((data) => data.userId === props.project.userId)
          ?.name || "";
      return { jobsiteName: jobsite, userName: user };
    }, [
      props.jobsiteNameList,
      props.userNameList,
      props.project.jobSiteId,
      props.project.userId,
    ]);

  let isGridView = props.viewType === EViewType.GRID;
  // ArMarker処理
  const [uploadedFailed, setUploadedFailed] = useState<boolean>(false);
  const [uploadedComp, setUploadedComp] = useState<boolean>(false);
  // shm処理
  const [sfmComp, setSfmComp] = useState<boolean>(false);
  const [sfmFailed, setSfmFailed] = useState<boolean>(false);
  // helmart処理
  const [helmertComp, sethelmertComp] = useState<boolean>(false);
  const [helmertFailed, setHelmertFailed] = useState<boolean>(false);
  // verification処理
  const [verificationComp, setVerificationComp] = useState<boolean>(false);

  const [dashboardUploadComp, setDashboardUploadComp] =
    useState<boolean>(false);

  //削除、プロジェクト名変更ボタン関連
  const [anchorEl, setAnchorEl] = useState(null);

  const [thumbnail, setThumbnail] = useState<string>();
  const jobsiteName = memoizedJobsiteName;
  const userName = memoizedUserName;
  const [projectName, setProjectName] = useState<string>();

  /**
   * CSS only creates line-break opportunities at spaces and "-"; "_" is an
   * alphabetic character (UAX #14), so "AAA_BBB_CCC" counts as ONE word: it is
   * pushed onto a new line as a whole and only then broken mid-word, leaving a
   * gap at the end of the previous line.
   * Insert <wbr /> after every "_" to add a valid break opportunity, keeping the
   * "_" at the end of the line just like "-" behaves. <wbr /> is used instead of
   * a zero-width space character so no stray character leaks into the text when
   * the user copies the project name.
   */
  const projectNameNodes = useMemo<ReactNode[]>(() => {
    const segments = (projectName ?? "").split("_");
    const nodes: ReactNode[] = [];
    segments.forEach((segment, index) => {
      const isLast = index === segments.length - 1;
      nodes.push(isLast ? segment : `${segment}_`);
      if (!isLast) nodes.push(<wbr key={index} />);
    });
    return nodes;
  }, [projectName]);

  /**
   * List view renders the date on the first line and the time on the second, so
   * the column no longer has to fit "DD/MM/YYYY HH:mm:ss" on a single line.
   * The source date follows the active sort (upload vs captured), same as the
   * grid view.
   */
  const { sortDateText, sortTimeText } = useMemo(() => {
    const sortDate = dayjs(
      Clusterings.resolveSortDate(props.project, props.sortBy),
    );
    return {
      sortDateText: sortDate.format(
        props.isLanguage ? "YYYY/MM/DD" : "DD/MM/YYYY",
      ),
      sortTimeText: sortDate.format("HH:mm:ss"),
    };
  }, [props.project, props.sortBy, props.isLanguage]);

  const [jobsiteId, setJobSiteId] = useState<string>();

  const [isAR, setIsAR] = useState<boolean>(false);
  const [openARListDialog, setOpenARListDialog] = useState<boolean>(false);

  const [messageModal, setMessageModal] = useState<string>("");

  const getThumbnail = async (controller: AbortController) => {
    try {
      axios
        .get(
          `${config.serverHost}/api/v1/project/${props.project.id}/thumbnail`,
          {
            withCredentials: true,
            signal: controller.signal,
          },
        )
        .then(async (res: AxiosResponse<string>) => {
          axios
            .get(`${res.data}`, {
              responseType: "blob",
              withCredentials: true,
              signal: controller.signal,
            })
            .then(async (res: AxiosResponse<Blob>) => {
              setThumbnail(URL.createObjectURL(res.data));
            });
        })
        .catch((err) => {
          if (axios.isCancel(err)) {
            // console.log("thumbnail request cancelled");
          } else {
            console.error(`thumbnail get err ${err}`);
          }
        });
    } catch (err) {
      console.error(`thumbnail get err ${err}`);
    }
  };

  const isUploadCompletedCheck = async () => {
    try {
      const res: AxiosResponse<Common.ProjectViDoc> =
        await projectDetailAPIs.uploadStatus.get(props.project.id);

      return res.status === 200; //  process COMPLETED
    } catch (err) {
      console.error(`thumbnail get err ${err}`);
    }
  };

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const memoizedGetThumbnail = useCallback(
    async (controller: AbortController) => {
      if (thumbnail) return;
      await getThumbnail(controller);
    },
    [thumbnail],
  );

  useEffect(() => {
    if (!inView) return;
    const controller = new AbortController();
    memoizedGetThumbnail(controller);
    return () => {
      controller.abort();
    };
  }, [inView, memoizedGetThumbnail]);

  const onDismissMessageModal = () => {
    setMessageModal("");
  };

  useEffect(() => {
    setProjectName(props.project.name);
  }, [props.project.name]);

  useEffect(() => {
    setProjectName(props.project.name);
    if (props.project.status) {
      setIsAR(props.project.status.is_ar);
      if (
        props.project.status.lidar_upload ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.lidar_upload ===
          Common.PROJECT_STATUS_ENUM.WAITING ||
        props.project.status.sfm_processing ===
          Common.PROJECT_STATUS_ENUM.PROCESSING ||
        props.project.status.sfm_processing ===
          Common.PROJECT_STATUS_ENUM.WAITING
      ) {
        setUploadedComp(true);
      }
      if (
        props.project.status.lidar_upload === Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setUploadedFailed(true);
      }
      if (
        props.project.status.sfm_processing ===
        Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setSfmComp(true);
      }
      if (
        props.project.status.sfm_processing === Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setSfmFailed(true);
      }
      if (
        props.project.status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.coordinate_transformation ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        sethelmertComp(true);
      }
      if (
        props.project.status.helmert_transformation ===
          Common.PROJECT_STATUS_ENUM.ERROR ||
        props.project.status.coordinate_transformation ===
          Common.PROJECT_STATUS_ENUM.ERROR
      ) {
        setHelmertFailed(true);
      }
      if (
        props.project.status.verification_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.verification_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setVerificationComp(true);
      }
      if (
        props.project.status.dashboard_upload_las_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_las_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_txt_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.dashboard_upload_txt_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.landlog_viewer_upload_helmert ===
          Common.PROJECT_STATUS_ENUM.COMPLETED ||
        props.project.status.landlog_viewer_upload_sfm ===
          Common.PROJECT_STATUS_ENUM.COMPLETED
      ) {
        setDashboardUploadComp(true);
      }
    }
  }, []);

  const { openUploadDialog } = useContext(uploadDialogContext);
  const { openRenameDialog } = useContext(renameDialogContext);
  const { openDeleteDialog } = useContext(deleteDialogContext);
  const navigate = useNavigate();
  //プロジェクト削除リスト
  const [selectList, setSelectList] = useState(false);
  //プロジェクト削除有効化フラグ
  const { isDelete } = useContext(deleteContext);
  useEffect(() => {
    if (isDelete === false) {
      setSelectList(false);
      props.selectProject.length = 0;
    }
  });

  const handleList = () => {
    !selectList
      ? props.setSelectProject([...props.selectProject, props.project])
      : props.setSelectProject(
          props.selectProject.filter((arr) => arr.id !== props.project.id),
        );
    setSelectList((prev) => !prev);
  };

  const handleThumbnailClick = (event: ReactMouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (isDelete) {
      handleList();
      return;
    }
    openProjectAfterCheck(props.project.id, isAR, {
      isReady: async () => (await isUploadCompletedCheck()) === true,
      onNotReady: () => setMessageModal(t("PROJECT_UPLOAD_PROCESSING")),
      origin: window.location.origin,
      openWindow: (url, target) => window.open(url, target),
    });
  };

  const handleClick = (event: any) => {
    // カード全体のクリック（別タブ起動）に伝播させない。
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e) => {
    setAnchorEl(null);
    e.stopPropagation();
  };

  const handleRowClick = async () => {
    if (isDelete) {
      handleList();
      return;
    }
    let ready = await isUploadCompletedCheck();
    if (!ready) {
      setMessageModal(t("PROJECT_UPLOAD_PROCESSING"));
      return;
    }
    sessionStorage.setItem("search", window.location.search);
    if (isAR) navigate(`ar/${props.project.id}`);
    else navigate(`/${props.project.id}`);
  };

  const handleDeleteDialogOpen = () => {
    setAnchorEl(null);
  };

  const handleRenameDialogOpen = () => {
    setAnchorEl(null);
  };

  // List View only: the ⋮ menu renders through a MUI Portal, so a click on a
  // menu item still bubbles up to the row Card's onClick (navigate) unless
  // each entry point stops it here.
  const withStopPropagation =
    (handler: () => void) => (e: React.MouseEvent) => {
      e.stopPropagation();
      handler();
    };

  const isEditing = () => {
    const status = props.project.status;
    const EDITING = Common.PROJECT_STATUS_ENUM.PROCESSING;
    return (
      status !== null &&
      (status.helmert_transformation === EDITING ||
        status.coordinate_transformation === EDITING ||
        status.point_splitting_lidar === EDITING ||
        status.remove_lidar === EDITING ||
        status.point_txt_lidar === EDITING ||
        status.point_splitting_sfm === EDITING ||
        status.remove_sfm === EDITING ||
        status.point_txt_sfm === EDITING ||
        status.point_splitting_helmert === EDITING ||
        status.remove_helmert === EDITING ||
        status.point_txt_helmert === EDITING)
    );
  };

  const theme = useTheme();
  const DARK = "dark";
  const removeIcon =
    theme.palette.mode === DARK ? POINT_REMOVE_WHITE_IMG : POINT_REMOVE_IMG;

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customMenuColor = {
    color: theme.palette.base.menu,
  };

  const selectedBorderColor =
    theme.palette.mode === DARK ? "#FFFFFF" : "#000000";

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customMainColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const RightIcon = () => {
    return (
      <div
        style={{
          height: "24px",
          width: "24px",
          right: "6px",
          position: "absolute",
        }}
      >
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  const getProjectItemStyle = () => {
    if (isGridView) {
      return {
        width: "220px",
        height: "290px",
      };
    } else {
      return {
        width: "100%",
      };
    }
  };

  return (
    <Grid
      item
      key={props.project.id}
      ref={ref}
      sx={{
        margin: isGridView ? "6.5px" : "0px",
        padding: "0px",
        ...getProjectItemStyle(),
      }}
    >
      <Card
        onClick={isGridView ? handleList : undefined}
        sx={{
          borderColor: selectedBorderColor,
          margin: "0px",
          flexDirection: isGridView ? "column" : "row",
          border: isGridView ? (selectList ? "solid 2px" : "0px") : "0px",
          boxShadow: isGridView
            ? "0 2px 8px rgba(0, 0, 0, 0.18)"
            : "none !important",
          ...getProjectItemStyle(),
        }}
      >
        {inView ? (
          isGridView ? (
            <Box component={"div"}>
              <Box
                component={"div"}
                sx={{
                  width: "100%",
                  height: "32px",
                  verticalAlign: "middle",
                  margin: "0px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="h5"
                  component="h5"
                  sx={{
                    height: "100%",
                    width: "100%",
                    paddingLeft: "8px",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    verticalAlign: "middle",
                  }}
                >
                  <Tooltip
                    title={projectName}
                    arrow
                    placement="top"
                    disableInteractive
                  >
                    <Box component={"div"} className="pj-tooltip">
                      {projectName}
                    </Box>
                  </Tooltip>
                </Typography>
                <IconButton
                  sx={{
                    display: "flex",
                    width: "30px",
                    height: "30px",
                    outline: "none",
                  }}
                  onClick={handleClick}
                >
                  <MoreVert fontSize="medium" sx={customColor} />
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  sx={{ top: "10px", borderRadius: "0px", left: "-132px" }}
                  PaperProps={{
                    style: {
                      backgroundColor: customMenuColor.color,
                      textAlign: "center",
                      borderRadius: "0px",
                    },
                  }}
                >
                  <MenuItem
                    onClick={handleRenameDialogOpen}
                    sx={{ width: "230px", padding: "5px", ...customColor }}
                  >
                    <div
                      onClick={() => {
                        openRenameDialog(props.project);
                        setAnchorEl(null);
                      }}
                      style={{
                        width: "100%",
                        height: "100%",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {t("CHANGE_TITLE")}
                      <RightIcon />
                    </div>
                  </MenuItem>
                  <MenuItem
                    onClick={handleDeleteDialogOpen}
                    sx={{ width: "230px", padding: "5px", ...customColor }}
                  >
                    <div
                      onClick={() => {
                        openDeleteDialog(props.project);
                        setAnchorEl(null);
                      }}
                      style={{
                        width: "100%",
                        height: "100%",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {t("REMOVE")}
                      <RightIcon />
                    </div>
                  </MenuItem>

                  {props.isARAvailable && (
                    <MenuItem
                      onClick={() => {
                        openUploadDialog(props.project);
                        setAnchorEl(null);
                      }}
                      sx={{ width: "230px", padding: "5px", ...customColor }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {t("UPLOAD")}
                        <RightIcon />
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </Box>
              <Box
                component={"div"}
                onClick={handleThumbnailClick}
                sx={{ position: "relative", cursor: "pointer" }}
              >
                <CardMedia
                  className="hover-cursor"
                  component="img"
                  height="100px"
                  width="220px"
                  image={
                    !isAR ? (thumbnail ? thumbnail : MOCK_IMAGE) : AR_IMAGE
                  }
                />
                <Avatar
                  sx={{
                    backgroundColor: props.project?.useViDoc
                      ? "#2E7D32"
                      : "#4C6CB3",
                    color: "white",
                    position: "absolute",
                    bottom: "0px",
                    right: "0px",
                    height: "24px",
                    width: "44px",
                    fontSize: "small",
                  }}
                  variant="square"
                >
                  <Typography
                    gutterBottom
                    variant="body2"
                    component="div"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      height: "20px",
                      margin: "0px",
                    }}
                  >
                    {props.project?.useViDoc ? "RTK" : "GPS"}
                  </Typography>
                </Avatar>
              </Box>
              <CardContent
                sx={{
                  padding: "8px !important",
                  display: "flex",
                  flexFlow: "column",
                  height: "158px",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  sx={{ padding: "0px" }}
                >
                  {props.isLanguage
                    ? dayjs(
                        Clusterings.resolveSortDate(
                          props.project,
                          props.sortBy,
                        ),
                      ).format("YYYY/MM/DD HH:mm:ss")
                    : dayjs(
                        Clusterings.resolveSortDate(
                          props.project,
                          props.sortBy,
                        ),
                      ).format("DD/MM/YYYY HH:mm:ss")}
                </Typography>
                <Box
                  component={"div"}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Tooltip
                    title={jobsiteName}
                    arrow
                    placement="top"
                    disableInteractive
                  >
                    <Typography
                      gutterBottom
                      variant="body2"
                      component="div"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        height: "20px",
                        margin: "0px",
                      }}
                    >
                      {jobsiteName}
                    </Typography>
                  </Tooltip>
                  <Box component={"div"}>
                    {(props.project.status.remove_helmert ===
                      Common.PROJECT_STATUS_ENUM.COMPLETED ||
                      props.project.status.remove_sfm ===
                        Common.PROJECT_STATUS_ENUM.COMPLETED ||
                      props.project.status.remove_lidar ===
                        Common.PROJECT_STATUS_ENUM.COMPLETED) && (
                      <Tooltip
                        title={
                          <span className="tool-tip-cal">
                            {t("REMOVED_POINT_CLOUD")}
                          </span>
                        }
                        arrow
                        placement="top"
                        disableInteractive
                      >
                        <img src={removeIcon} alt="" />
                      </Tooltip>
                    )}
                  </Box>
                </Box>
                <Typography
                  gutterBottom
                  variant="body2"
                  component="div"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    height: "20px",
                    margin: "0px",
                  }}
                >
                  {userName}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    component={"div"}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <StatusIcon
                      status={uploadedComp ? 1 : uploadedFailed ? 2 : 0}
                      number={1}
                    />
                    <span style={{ margin: "0 3px" }}></span>
                    <StatusIcon
                      status={sfmComp ? 1 : sfmFailed ? 2 : 0}
                      number={2}
                    />
                    <span style={{ margin: "0 3px" }}></span>
                    <StatusIcon
                      status={helmertComp ? 1 : helmertFailed ? 2 : 0}
                      number={3}
                    />
                    <span style={{ margin: "0 3px" }}></span>
                    <StatusIcon status={verificationComp ? 1 : 0} number={4} />
                    <span style={{ margin: "0 3px" }}></span>
                    <StatusIcon
                      status={dashboardUploadComp ? 1 : 0}
                      number={5}
                    />
                  </Box>
                  {isEditing() && (
                    <Tooltip
                      title={
                        <span className="tool-tip-cal">{t("WHILE_EDIT")}</span>
                      }
                      arrow
                      placement="top"
                      disableInteractive
                    >
                      <DownloadingIcon
                        sx={{
                          color:
                            theme.palette.mode === DARK ? "white" : "#140A94",
                          width: "24px",
                          height: "24px",
                          transform: "rotate(180deg)",
                        }}
                      />
                    </Tooltip>
                  )}
                </Box>
                <StatusText
                  status={props.project.status}
                  isLanguage={props.isLanguage}
                />
              </CardContent>
            </Box>
          ) : (
            <Box component={"div"} sx={{ position: "relative", width: "100%" }}>
              <Card
                key={props.project.id}
                sx={{
                  borderColor: selectedBorderColor,
                  border: selectList
                    ? `2px solid ${selectedBorderColor}`
                    : "1px solid transparent",
                  width: "100%",
                  boxShadow: selectList
                    ? "0 1px 4px rgba(25, 118, 210, 0.12)"
                    : "0 1px 3px rgba(0, 0, 0, 0.06)",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  margin: "4px 0",
                }}
              >
                <Grid container columns={56} alignItems={"center"} spacing={0}>
                  <Grid item xs={8}>
                    <Box
                      component={"div"}
                      onClick={handleThumbnailClick}
                      sx={{ cursor: "pointer" }}
                    >
                      <CardMedia
                        className="hover-cursor"
                        component="img"
                        style={{
                          height: "100px",
                          width: "100%",
                          maxWidth: "220px",
                          borderRadius: "6px",
                          objectFit: "cover",
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        }}
                        image={
                          !isAR
                            ? thumbnail
                              ? thumbnail
                              : MOCK_IMAGE
                            : AR_IMAGE
                        }
                      />
                    </Box>
                  </Grid>
                  {/* Project Name */}
                  <Grid item xs={11}>
                    <Typography
                      sx={{
                        padding: "0 12px",
                        fontWeight: 500,
                        fontSize: "15px",
                        lineHeight: 1.4,
                      }}
                    >
                      <Tooltip
                        title={projectName}
                        arrow
                        placement="top"
                        disableInteractive
                      >
                        <Box
                          component={"div"}
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 4,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                          }}
                        >
                          {projectNameNodes}
                        </Box>
                      </Tooltip>
                    </Typography>
                  </Grid>
                  {/* Jobsite */}
                  <Grid item xs={8}>
                    <Tooltip
                      title={jobsiteName}
                      arrow
                      placement="top"
                      disableInteractive
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          padding: "0 8px",
                          textAlign: "center",
                          color: "text.secondary",
                        }}
                      >
                        {jobsiteName}
                      </Typography>
                    </Tooltip>
                  </Grid>
                  {/* Photographer */}
                  <Grid item xs={6}>
                    <Typography
                      variant="body2"
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "0 8px",
                        textAlign: "center",
                        color: "text.secondary",
                      }}
                    >
                      {userName}
                    </Typography>
                  </Grid>
                  {/* Type */}
                  <Grid item xs={3}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Avatar
                        sx={{
                          backgroundColor: props.project?.useViDoc
                            ? "#2E7D32"
                            : "#4C6CB3",
                          color: "white",
                          height: "28px",
                          width: "52px",
                          fontSize: "12px",
                          fontWeight: 600,
                          borderRadius: "14px",
                        }}
                        variant="rounded"
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 600,
                            fontSize: "11px",
                          }}
                        >
                          {props.project?.useViDoc ? "RTK" : "GPS"}
                        </Typography>
                      </Avatar>
                    </Box>
                  </Grid>
                  {/* Date */}
                  <Grid item xs={7}>
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        padding: "0 2px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "text.secondary",
                        // nowrap applies per line: keeps the date and the time
                        // each intact instead of breaking inside "DD/MM/YYYY".
                        whiteSpace: "nowrap",
                        lineHeight: 1.35,
                      }}
                    >
                      <Box component="span" sx={{ display: "block" }}>
                        {sortDateText}
                      </Box>
                      <Box component="span" sx={{ display: "block" }}>
                        {sortTimeText}
                      </Box>
                    </Typography>
                  </Grid>
                  {/* Number of image */}
                  <Grid item xs={4}>
                    <Typography
                      variant="body2"
                      sx={{
                        padding: "0 8px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "text.secondary",
                      }}
                    >
                      {props.project.numberOfImage ?? "-"}
                    </Typography>
                  </Grid>
                  {/* Status */}
                  <Grid item xs={8}>
                    <Box sx={{ textAlign: "left" }}>
                      <StatusText
                        status={props.project.status}
                        isLanguage={props.isLanguage}
                        wrapTwoLines
                      />
                    </Box>
                  </Grid>
                  {/* Actions */}
                  <Grid item xs={1}>
                    <IconButton
                      disabled={isDelete}
                      sx={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                      }}
                    >
                      <MoreVert fontSize="medium" sx={customColor} />
                    </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      sx={{ top: "0px", borderRadius: "0px", left: "-40px" }}
                      PaperProps={{
                        style: {
                          backgroundColor: customMenuColor.color,
                          textAlign: "center",
                          borderRadius: "0px",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={withStopPropagation(handleRenameDialogOpen)}
                        sx={{ width: "230px", padding: "5px", ...customColor }}
                      >
                        <div
                          onClick={() => {
                            openRenameDialog(props.project);
                            setAnchorEl(null);
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {t("CHANGE_TITLE")}
                          <RightIcon />
                        </div>
                      </MenuItem>
                      <MenuItem
                        onClick={withStopPropagation(handleDeleteDialogOpen)}
                        sx={{ width: "230px", padding: "5px", ...customColor }}
                      >
                        <div
                          onClick={() => {
                            openDeleteDialog(props.project);
                            setAnchorEl(null);
                          }}
                          style={{
                            width: "100%",
                            height: "100%",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          {t("REMOVE")}
                          <RightIcon />
                        </div>
                      </MenuItem>
                      {props.isARAvailable && (
                        <MenuItem
                          onClick={withStopPropagation(() => {
                            openUploadDialog(props.project);
                            setAnchorEl(null);
                          })}
                          sx={{
                            width: "230px",
                            padding: "5px",
                            ...customColor,
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {t("UPLOAD")}
                            <RightIcon />
                          </div>
                        </MenuItem>
                      )}
                    </Menu>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          )
        ) : (
          <></>
        )}
        {/* アップロード完了ダイアログ
            Rendered outside the isGridView branches so both the Grid view
            (thumbnail click) and the List view (row click) show it. */}
        <Dialog
          open={!!messageModal && messageModal.trim() !== ""}
          PaperProps={{
            className: "message-modal-container",
            style: { ...customBackgroundStyles },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          <DialogContentText
            sx={{
              padding: "0 20px",
              textAlign: "center !important",
              color: theme.palette.text.primary,
              width: "100%",
            }}
            id="upload-file20"
          >
            {messageModal}
          </DialogContentText>
          <Button
            style={customMainColor}
            className="upload-file22"
            size="small"
            variant="contained"
            onClick={withStopPropagation(onDismissMessageModal)}
          >
            {"OK"}
          </Button>
        </Dialog>
      </Card>
    </Grid>
  );
};

export default memo(Project);
